import React from 'react';
import {ReactTabulator} from "react-tabulator";
import TabulatorTableOptions from "../../../utils/TabulatorTableOptions"

const TableView = (props) => {


  return (

    <div style={{"height": props.height }} >
      <ReactTabulator
        columns={props.data.column}
        data={props.data.data}
        options={TabulatorTableOptions.style2TaskView}
        />
    </div>

  );
};

export default TableView;
